export default __webpack_public_path__ + "static/media/dark-sound.cde79d7d.png";